import thinkCard from './think'
// import productInfoCard from './product-info-card'
// import scriptExecCard from './script-exec-card'
// import videoInfoCard from './video-info-card'
// import video_gen_card from '../video-gen-card'
// import actionButtonCard from './action-button-card'
// import adInfoCard from './ad-info-card'
// import adCreateInfoCard from './ad-create-info-card'
// import videoTypeSelectionCard from './video-type-selection-card'
// import startMonitoringCard from './start-monitoring-card'

// import product_info_card from '../product-info-card'

const templateMap = {
  think: thinkCard
  // video_gen_card: video_gen_card
  // product_info_card: productInfoCard,
  // script_exec_card: scriptExecCard,
  // video_info_card: videoInfoCard,
  // action_button_card: actionButtonCard,
  // ad_info_card: adInfoCard,
  // ad_create_card: adCreateInfoCard,
  // video_type_selection_card: videoTypeSelectionCard,
  // product_info_card: product_info_card
  // start_monitoring_card: startMonitoringCard
}

export default templateMap
